import { ErrorPage } from "@/components/ui/ErrorPage";

export default function TestChiuso() {
  return (
    <ErrorPage
      emoji="🚪"
      titolo="Test non più disponibile"
      messaggio="Questo test è stato chiuso dal docente e non accetta più risposte."
      cta={{ label: "Torna alla tua area", to: "/area" }}
    />
  );
}
